import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drawer"
export default class extends Controller {
  static targets = ["overlay", "panel", "spinner", "body"];

  // https://stackoverflow.com/questions/57318097/stimulus-controller-event-listened-multiple-times-how-do-i-remove-event-listen
  initialize() {
    this.boundOpen = this.open.bind(this)
    this.boundClose = this.close.bind(this)
  }

  connect() {
    document.addEventListener('drawer.open', this.boundOpen); 
    document.addEventListener('drawer.close', this.boundClose);

    this.classToClose = "translate-x-[500px]";

    // auto open a drawer if the query params include "drawer=<url>"
    var params = new URLSearchParams(window.location.search)
    var drawerUrl = params.get("drawer")
    params.delete("drawer")

    var path = window.location.pathname
    var pathAndParams = path
    if (params.entries.length > 0) {
      pathAndParams += "?" + params.toString()
    }

    if (drawerUrl !== null) {
      // we want to remove the drawer from the URL so no future connect's open it again, causing an infinite loop
      window.history.pushState(null, null, pathAndParams)
      
      this.open({ url: drawerUrl })
      
    }
  }

  disconnect() {
    document.removeEventListener('drawer.open', this.boundOpen) 
    document.removeEventListener('drawer.close', this.boundClose)
  }

  open(event) {
    if (this.opening) {
      return;
    }
    this.opening = true;

    this.overlayTarget.classList.remove("hidden");
    this.panelTarget.classList.remove(this.classToClose);
    this.bodyTarget.classList.add("hidden");
    this.spinnerTarget.classList.remove("hidden");

    // Prevent scrolling the background/page while the drawer is open
    // For now, this is disabled because admin wants to be able to scroll while drawers are open
    //document.body.classList.add("overflow-hidden");

    var url = event.url;
    if (event.context && event.context.length > 0) {
      // The context is a JSON string.  We need to parse it and convert URL params.
      var context = JSON.parse(event.context);
      var params = new URLSearchParams(context);
      if (url.indexOf("?") > -1) {
        url += "&" + params.toString();
      } else {
        url += "?" + params.toString();
      }
    }

    $.ajax({
      type: 'GET',
      url: url,
      success: (response) => {
        this.bodyTarget.innerHTML = response;
        this.spinnerTarget.classList.add("hidden");
        this.bodyTarget.classList.remove("hidden");
        this.opening = false;
      },
      error: (xhr, textStatus, errorThrown) => {
        this.bodyTarget.innerHTML = "<div>Sorry, we encountered a problem.  We were notified and we'll look into it, but feel free to <a href='mailto:help@goodbill.com' class='chat'>talk to us</a>.";
        this.spinnerTarget.classList.add("hidden");
        this.bodyTarget.classList.remove("hidden");
        this.opening = false;
      }
    });  
  }

  close(event) {
    // if this comes from a button, it will still submit the form. if it doesn't come from a button, will this do anything bad? i don't think so.
    event.preventDefault();
    this.overlayTarget.classList.add("hidden");
    this.panelTarget.classList.add(this.classToClose);

    // Re-enable scrolling the background/page
    // Disabled for admins who want to be able to scroll while drawers are open
    //document.body.classList.remove("overflow-hidden");
  }
}
